<template>
  <div>
    <page-header>
      <template #breadcrumbs>
        <router-link to="/vacancies">Реестр работодателя</router-link> &raquo;
        <template v-if="item && item.name">{{ item.name }}</template>
        <template v-else>Новая карточка</template>
      </template>
      <h2>Карточка работодателя</h2>
    </page-header>

    <ul class="nav nav-tabs nav-justified p-3 d-flex align-items-center">
      <li class="nav-item">
        <a class="nav-link" @click.prevent="setActive('tab1')" :class="{ active: isActive('tab1') }" href="#tab1">Вакансии</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" @click.prevent="setActive('tab2')" :class="{ active: isActive('tab2') }" href="#tab2">История
          контактов</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" @click.prevent="setActive('tab3')" :class="{ active: isActive('tab3') }" href="#tab3">Общая
          информация</a>
      </li>
    </ul>
    <div class="card">
      <div>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade" :class="{ 'active show': isActive('tab1') }" id="tab1">
            <vacancy-tab-items :vacancy-id="item.id" :is-readonly="isReadonly"/>
          </div>
          <div class="tab-pane fade" :class="{ 'active show': isActive('tab2') }" id="tab2">
            <vacancy-tab-history :vacancy-id="item.id" :can-edit="!isReadonly"/>
          </div>
          <div class="tab-pane fade" :class="{ 'active show': isActive('tab3') }" id="tab3"
               v-disable-all="isReadonly">
            <div class="row pb-2">
              <div class="form-group col col-md-12 required">
                <component-input
                    label="Наименование" required
                    v-model="item.name"/>
              </div>
            </div>
            <div class="row pb-2">
              <div class="form-group col col-md-12">
                <label class="control-label">Основной вид деятельности</label>
                <textarea v-model="item.primaryOccupation" class="form-control" rows="3"></textarea>
              </div>
            </div>
            <div class="row pb-2">
              <div class="form-group col col-md-12">
                <component-input
                    label="Адрес сайта"
                    v-model="item.www"/>
              </div>
            </div>
            <div class="row pb-2">
              <div class="form-group col col-md-12">
                <component-input
                    label="Адрес"
                    v-model="item.Address"/>
              </div>
            </div>
            <div class="row pb-2">
              <div class="form-group col col-md-12 required">
                <component-input
                    label="ФИО контактного лица" required
                    v-model="item.contactPerson"/>
              </div>
            </div>
            <div class="row pb-2">
              <div class="form-group col col-md-4 required">
                <component-input
                    type="phone"
                    label="Контактный телефон" required
                    v-model="item.contactPhone"/>
              </div>
              <div class="form-group col col-md-4">
                <component-input
                    label="Контактный факс"
                    v-model="item.contactFax"/>
              </div>
              <div class="form-group col col-md-4 required">
                <component-input
                    label="Контактный E-mail" required
                    v-model="item.contactEmail"/>
                <div class="invalid-msg" v-if="v$.item.contactEmail.$error">Введите корректные данные</div>
              </div>
            </div>
            <div class="row pb-2">
              <div class="form-group col col-md-4 required">
                <component-input
                    label="ИНН" required
                    v-model="item.inn"/>
                <div class="invalid-msg" v-if="v$.item.inn.$error">Введите корректные данные</div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer mt-5">
          <div class="d-flex align-items-center float-right">
            <button-component class="btn btn-primary mx-2" v-on:click="save" v-if="!isReadonly">Сохранить
            </button-component>
            <button-component kind="secondary" type="button" class="btn btn-default" v-on:click="close">Закрыть
            </button-component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from "@/common/components/page/PageHeader";
import ButtonComponent from "@/common/ui/ButtonComponent";
import API from '../api/vacancy'
import ComponentInput from "@/common/components/ComponentInput";
import Constants from "@/common/constants";
import {required, email} from "@vuelidate/validators";
import {useVuelidate} from '@vuelidate/core'
import VacancyTabItems from "../components/VacancyTabItems";
import VacancyTabHistory from "../components/VacancyTabHistory";
import disableAll from "@/common/directives/disable-all";

const innValidator = (value) => value === null || value === undefined || value === '' || (new RegExp("^[0-9]{10,12}$", "g").test(value) && (value.length == 10 || value.length == 12));

export default {
  name: "VacancyCard",
  components: {
    VacancyTabHistory,
    VacancyTabItems,
    PageHeader,
    ButtonComponent,
    ComponentInput
  },
  directives: {
    'disable-all': disableAll
  },
  created() {
    this.loadPage();
  },
  data() {
    return {
      id: this.$route.params.id,
      isReadonly: this.$route.params.action === "view",
      item: {},
      activeItem: 'tab1',
    };
  },
  methods: {
    isActive(menuItem) {
      return this.activeItem === menuItem
    },
    setActive(menuItem) {
      this.activeItem = menuItem
    },
    loadPage() {
      API.find(this.id).then((response) => {
        if (response.data) {
          this.item = response.data;
        } else {
          this.item = {
            vacancyItems: []
          };
        }
      });
    },
    save() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
        return;
      }

      API.save(this.item).then((response) => {
        const msg = 'Данные успешно сохранены.'
        Constants.alert.fire('Сохранение', response.data.success ? msg : response.data.message, response.data.success ? 'success' : 'error');
        if (response.data.success) {
          this.$router.push({path: '/vacancies'});
        }
      });
    },
    close() {
      this.$router.push({path: '/vacancies'});
    }
  },
  setup: () => ({v$: useVuelidate()}),
  validations() {
    return {
      item: {
        inn: {required, innValidator},
        contactEmail: {email}
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";

.nav-tabs {
  justify-content: center;
  border: none;

  .nav-item {
    max-width: 240px;
    width: 100%;
    margin-top: 12px;
    min-width: 250px;
    margin-left: 8px;
    margin-right: 8px;

    .nav-link {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 14.5px 20px;
      font-family: "Source Sans Pro", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 120%;
      color: $gray-dark;
      border: 1px solid $gray-light1;
      box-sizing: border-box;
      border-radius: 6px;

      &.active {
        color: $blue-light;
        border: 1px solid $blue-light;
      }
    }
  }
}

.card {
  padding: 24px;
  margin: 16px 24px 0 24px;
  border-radius: 12px;
  border: none;
  box-shadow: none;
  background-color: #fff;
}

</style>